// components/Login.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack,
  FormControlLabel, Checkbox,
} from '@mui/material';
import api from './api/axios';
import { useUser } from './contexts/UserContext';

/**
 * Login.jsx — ID 저장만 지원하는 간결 버전
 */

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberId, setRememberId] = useState(false);

  const navigate = useNavigate();
  const { userInfo, refreshUserInfo } = useUser();

  useEffect(() => {
    if (userInfo?.logged_in) {
      navigate('/main', { replace: true });
    }
  }, [userInfo, navigate]);

  // ───────── 마운트 시 localStorage 로드 ─────────
  useEffect(() => {
    const savedId = localStorage.getItem('savedUsername');
    if (savedId) {
      setUsername(savedId);
      setRememberId(true);
    }
  }, []);

  // ───────── 로그인 핸들러 ─────────
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert('아이디와 비밀번호를 입력해주세요.');
      return;
    }

    try {
      await api.get('/api/accounts/csrf/');

      const res = await api.post('/api/accounts/login/', {
        username,
        password,
      });

      if (res.data.success) {
        if (rememberId) {
          localStorage.setItem('savedUsername', username);
        } else {
          localStorage.removeItem('savedUsername');
        }

        sessionStorage.removeItem('authenticated_private_rooms');
        for (let key in sessionStorage) {
          if (key.startsWith('nickname_')) sessionStorage.removeItem(key);
        }

        await refreshUserInfo();
        alert('로그인 성공! 페이지를 이동합니다.');
        navigate('/main');
      } else {
        alert(res.data.message || '아이디 또는 비밀번호가 틀렸습니다.');
      }
    } catch (err) {
      if (err.response?.status === 403) {
        alert('정지된 계정입니다. 관리자에게 문의해주세요.');
      } else if (err.response) {
        alert(`서버 오류: ${err.response.data.message || '알 수 없는 오류'}`);
      } else if (err.request) {
        alert('서버와의 연결을 확인해주세요.');
      } else {
        alert(`오류 발생: ${err.message}`);
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Card sx={{ width: 400, p: 3 }}>
        <CardContent>
          <Typography variant="h4" sx={{ fontFamily: `'Dancing Script', cursive`, fontWeight: 'bold', textAlign: 'center', mb: 3 }}>
            SanDle Login
          </Typography>

          <form onSubmit={handleLogin}>
            <Stack spacing={2}>
              <TextField label="아이디" value={username} onChange={(e) => setUsername(e.target.value)} fullWidth />
              <TextField label="비밀번호" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth />

              {/* ID 저장 체크박스 */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={<Checkbox checked={rememberId} onChange={(e) => setRememberId(e.target.checked)} />}
                  label="ID 저장"
                />
              </Box>

              <Button variant="contained" color="primary" type="submit" fullWidth>
                로그인
              </Button>
              <Button variant="outlined" color="secondary" onClick={() => navigate('/signup')} fullWidth>
                회원가입
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
